import { AnswerWrongReason } from './answer-wrong-feedback.model';

export const answerWrongReasonContent: AnswerWrongReason = {
  title: 'Why wasn’t this answer helpful?',
  options: [
    { title: 'One or more of the resources provided are incorrect', subtitle: 'Select the incorrect resources' },
    { title: 'One or more of the resources provided are outdated', subtitle: 'Select the outdated resources' },
    { title: 'Answer is incorrect despite a correct resources selection' },
    { title: 'No relevant resources were provided' },
  ],
  positiveFreeText: {
    title: 'Anything else you’d like to share?',
    placeholder: 'I have feedback on...',
  },
  negativeFreeText: {
    title: 'How can we improve this answer?',
    placeholder: 'Share more details, paste URLs to the correct articles, or any other feedback',
  },
  freeTextLimitWarning: 'Maximum character limit reached',
  buttonsPrimaryText: 'Send',
  buttonsSecondaryText: 'Cancel',
};
